import {SimpleChanges} from '@angular/core';

export class ChangeDetectionHelper {
    public static needsOnChangeATick(changes: SimpleChanges): boolean {
        for (const propName in changes) {
            if (!changes[propName].isFirstChange()) {
                return true;
            }
        }
        return false;
    }
}
